import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { leads } from "../../../../../../redux/leads/action";
import { selectLeadsListItems } from "../../../../../../redux/leads/selector";

const TransporterLeads = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectLeadsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'LeadInfo.Name', headerName: 'Name', sortable: true, filter: true ,isEdit: true  },
          { field: 'LeadInfo.Email', headerName: 'Email' },
          { field: 'LeadInfo.PhoneNumber', headerName: 'Phone', sortable: true, filter: true },
          { field: 'LeadInfo.start.location.address.building', headerName: 'From Address' },
          { field: 'LeadInfo.end.location.address.building', headerName: 'To Address' },  
        ]);
      }
      const fetchLeads=()=>{
        dispatch(leads.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/leads/list`,entity:'leads',jsonData:{
          "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchLeads()
	}, [pageData])

	return (
   
		<Table columnData={columnDefs} rowData={orderItems?.result?.items}  setPageData={setPageData}
    paginationData={orderItems?.result?.pagination} headingName="Leads"/>
      
     
	);
};

export default TransporterLeads;


